import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";
import NodeService from "../node/NodeService";

export const mapItems = (data) => {
  return {...data, id: data.id, uuidOrFriendlyName: data.uuid + ' - ' + data.friendlyName};
};

class NodeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Node',
      label: 'uuidOrFriendlyName',
      value: 'id',
      mapItems,
      url: NodeService.ALL_URL +'?size=5000'
    };
  }
}

NodeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default NodeSelector;



// WEBPACK FOOTER //
// ./src/gateways/component/NodeSelector.js